import React, { useContext, useEffect, useState } from 'react'
import { getApiTargetInfo } from 'core'
import { connect } from 'react-redux'
import CommonScreen from 'admin/component/CommonScreen'

import {
  dateCol,
  dateTimeCol,
  intCol,
  numCol,
  strCol,
} from '@integec/grid-tools/lib/cols'
import { getSolarLsbpEvents, importSolarLsbpEvents } from './../solarapi'
import R from 'ramda'
import { Button, DatePicker, message, Select } from 'antd'

import moment from 'moment'
import { ErrorContext } from 'context'
import { getSolarPlant } from 'api/pgads'

const title = 'Solar SF Events'

const SolarLSBPMeasurment = ({ apiTargetInfo }) => {
  const { setError } = useContext(ErrorContext)

  const [date, setDate] = useState(
    moment()
      .subtract(1, 'month')
      .startOf('month')
  )
  const [plantMap, setPlantMap] = useState([])
  useEffect(
    _ => {
      getSolarPlant(apiTargetInfo).fork(setError, data => {
        const pm = R.reduce(
          (a, b) => ({ ...a, ...b }),
          {},
          data.map(d => ({ [d.plantId]: d.plantName }))
        )
        setPlantMap(pm)
      })
    },
    [apiTargetInfo, setError]
  )

  const screenCriteria = (s, p, u, onChange) => {
    return (
      <DatePicker.MonthPicker
        style={{ marginLeft: '15px' }}
        allowClear={false}
        format="MMM YYYY"
        value={date}
        onChange={d => {
          setDate(d)
          onChange()
        }}
      />
    )
  }
  const [selPlantImport, setSelPlantImport] = useState([])
  const extraCriteriaAfterButton = () => {
    return (
      <div style={{ border: '1px solid gray', padding: 5 }}>
        <Button
          // loading={importing}
          onClick={importData}
          style={{ marginLeft: '10px' }}
          type="danger"
          icon="thunderbolt"
        >
          Import Data
        </Button>
        <DatePicker.MonthPicker
          style={{ marginLeft: '15px' }}
          allowClear={false}
          format="MMM YYYY"
          value={date}
          onChange={d => {
            setDate(d)
          }}
        />
        <Select
          id="plant"
          showSearch
          style={{ width: 250, marginLeft: 10 }}
          value={selPlantImport}
          onChange={val => {
            setSelPlantImport(val)
          }}
          // mode="multiple"
          placeholder="Select Plant"
        >
          <Select.Option value="ALL">ALL</Select.Option>
          {R.compose(
            R.sortBy(R.prop('value')),
            R.map(([k, v]) => ({ id: k, value: v })),
            R.toPairs
          )(plantMap).map(k => (
            <Select.Option value={k.id} key={k.id}>
              {/* {`${k}-${keymap[k]}`} */}
              {`${k.id} - ${k.value}`}
            </Select.Option>
          ))}
        </Select>
      </div>
    )
  }

  const importData = _ => {
    if (selPlantImport.length <= 0) {
      message.warn('Please, Select Plant.')

      return
    }
    importSolarLsbpEvents(apiTargetInfo)(withCriteria()).fork(setError, _ =>
      message.info('Data started importing, Please check data after sometime.')
    )
  }

  const withCriteria = () => {
    return {
      year: date.format('YYYY'),
      month: date.format('MM'),
      selPlantImport: !selPlantImport.includes('ALL')
        ? selPlantImport
        : Object.keys(plantMap),
    }
  }

  return (
    <CommonScreen
      autoRetrieve={false}
      screenCriteria={screenCriteria}
      extraCriteriaAfterButton={extraCriteriaAfterButton}
      withCriteria={withCriteria}
      title={title}
      allowInsert={false}
      withoutModify
      withDelete={false}
      header={SolarLsbpSfEventsHeaders}
      saveTask={_ => _}
      retrieveTask={getSolarLsbpEvents}
      deleteTask={_ => _}
      // widthOffset={50}
      insertComp={false}
      insertCompHeight={0}
      onInsertEvent={_ => _}
      autoFixColByKey={false}
      headerRowHeight={60}
      // totalWidth={150 + 650 + 700 + 150}
      initialSortOptions={SolarLsbpSfEventsHeaders}
      // sortOptions={SolarLsbpSfEventsHeaders}
      defaultInsertData={{ accessRight: 'R' }}
      heightOffset={200}
      // autoFixColByKey
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(SolarLSBPMeasurment)

const SolarLsbpSfEventsHeaders = [
  strCol({
    ident: 'id',
    display: 'Id',
    isKey: true,
    sortOrder: 'asc',
    width: 250,
  }),
  strCol({
    ident: 'siteName',
    display: 'Site Name',
    isKey: true,
    // sortOrder: 'asc',
    width: 200,
  }),
  strCol({
    ident: 'siteReference',
    display: 'Site Reference',
    isKey: false,
    // sortOrder: 'asc',
    width: 200,
  }),
  strCol({
    ident: 'nercId',
    display: 'NERC Id',
    isKey: false,
    // sortOrder: 'asc',
  }),
  intCol({
    ident: 'year',
    display: 'Year',
    isFiltered: true,
    // sortOrder: 'asc',
  }),
  intCol({
    ident: 'month',
    display: 'Month',
    isFiltered: true,
    // sortOrder: 'asc',
  }),
  strCol({
    ident: 'relatedComponent',
    display: 'Related Component',
    isFiltered: true,
    sortOrder: 'asc',
    width: 250,
  }),
  numCol({
    ident: 'capacityRelatedComponent',
    display: 'Capacity Related Component',
    isFiltered: true,
    // sortOrder: 'asc',
  }),
  strCol({
    ident: 'componentStatus',
    display: 'Component Status',
    isFiltered: true,
    // sortOrder: 'asc',
    width: 250,
  }),
  dateTimeCol({
    ident: 'eventStartTime',
    display: 'Event Start Time',
    isFiltered: true,
    // sortOrder: 'asc',
    width: 250,
  }),
  dateTimeCol({
    ident: 'eventEndTime',
    display: 'Event End Time',
    isFiltered: true,
    // sortOrder: 'asc',
    width: 250,
  }),
  numCol({
    ident: 'durationHours',
    display: 'Duration Hours',
    isFiltered: true,
    // sortOrder: 'asc',
  }),
  numCol({
    ident: 'activeHours',
    display: 'Active Hours',
    isFiltered: true,
    // sortOrder: 'asc',
  }),
  numCol({
    ident: 'energyLostMwh',
    display: 'Energy Lost MWh',
    isFiltered: true,
    // sortOrder: 'asc',
  }),

  strCol({
    ident: 'remediation',
    display: 'Remediation',
    isFiltered: true,
    // sortOrder: 'asc',
  }),
  strCol({
    ident: 'fault',
    display: 'Fault',
    isFiltered: true,
    // sortOrder: 'asc',
    width: 200,
  }),
  strCol({
    ident: 'faultComponent',
    display: 'Fault Component',
    isFiltered: true,
    // sortOrder: 'asc',
  }),
  strCol({
    ident: 'failureMode',
    display: 'Failure Mode',
    isFiltered: true,
    // sortOrder: 'asc',
    width: 200,
  }),
  strCol({
    ident: 'failureMechanism',
    display: 'Failure Mechanism',
    isFiltered: true,
    // sortOrder: 'asc',
  }),
  strCol({
    ident: 'category',
    display: 'Category',
    isFiltered: true,
    // sortOrder: 'asc',
  }),
  strCol({
    ident: 'subcategory',
    display: 'Subcategory',
    isFiltered: true,
    // sortOrder: 'asc',
  }),
  strCol({
    ident: 'resolutionCategory',
    display: 'Resolution Category',
    isFiltered: true,
    // sortOrder: 'asc',
  }),
  strCol({
    ident: 'excludable',
    display: 'Excludable',
    isFiltered: true,
    // sortOrder: 'asc',
  }),
  dateTimeCol({
    ident: 'exclusionStartTime',
    display: 'Exclusion Start Time',
    isFiltered: true,
    // sortOrder: 'asc',
  }),
  dateTimeCol({
    ident: 'exclusionEndTime',
    display: 'Exclusion End Time',
    isFiltered: true,
    // sortOrder: 'asc',
  }),
  strCol({
    ident: 'excludableCategory',
    display: 'Excludable Category',
    isFiltered: true,
    // sortOrder: 'asc',
    width: 150,
  }),
  strCol({
    ident: 'exclusionRationale',
    display: 'Exclusion Rationale',
    isFiltered: true,
    // sortOrder: 'asc',
    width: 150,
  }),
  strCol({
    ident: 'incidentStatus',
    display: 'Incident Status',
    isFiltered: true,
    // sortOrder: 'asc',
  }),
  strCol({
    ident: 'categorizationStatus',
    display: 'Categorization Status',
    isFiltered: true,
    // sortOrder: 'asc',
    width: 150,
  }),

  numCol({
    ident: 'weightedDowntime',
    display: 'Weighted Downtime',
    isFiltered: true,
    // // sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'contributiontoDowntimePercent',
    display: 'Contribution To Downtime Percent',
    isFiltered: true,
    // // sortOrder: 'asc',
    width: 150,
  }),

  numCol({
    ident: 'rawContributiontoDowntimePercent',
    display: 'Raw Contribution To Downtime Percent',
    isFiltered: true,
    // // sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'rawWeightedDowntime',
    display: 'Raw Weighted Downtime',
    isFiltered: true,
    // // sortOrder: 'asc',
    width: 150,
  }),

  strCol({
    ident: 'processExecId',
    display: 'Process Exec Id',
    isFiltered: true,
    // sortOrder: 'asc',
    width: 150,
  }),
  dateCol({
    ident: 'createdTs',
    display: 'CreatedTs',
    isFiltered: true,
    // sortOrder: 'asc',
    width: 150,
  }),
  strCol({
    ident: 'comments',
    display: 'Comments',
    isFiltered: true,
    // sortOrder: 'asc',
    alignment: 'left',
    ellipsis: true,
    width: 300,
  }),
  strCol({
    ident: 'loadFile',
    display: 'LoadFile',
    isFiltered: true,
    // sortOrder: 'asc',
    width: 150,
  }),
].map(d => ({ ...d, width: d.width || 200, ellipsis: true }))
